import './index.scss'
import Loader from 'react-loaders';
import AnimatedLetters from '../AnimatedLetters/index';
import { useState, useEffect, useRef } from 'react';
import emailjs from '@emailjs/browser'
import { MapContainer } from '../../../node_modules/react-leaflet/lib/MapContainer';
import { TileLayer } from '../../../node_modules/react-leaflet/lib/TileLayer';
import { Marker } from '../../../node_modules/react-leaflet/lib/Marker';
import { Popup } from '../../../node_modules/react-leaflet/lib/Popup';

const Contact = () => {
    const [letterClass, setLetterClass] = useState('text-animate')
    const refForm = useRef()

    useEffect(() => {
        setTimeout(() => {
            return setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm('service_y7mu6e5', 'template_6znpsqy', refForm.current, 'I8kQhd26N8WCK3OAr')
            .then(
                (result) => {
                    console.log(result.text)
                    alert('Email was sent successfully!')
                    window.location.reload(false)
                },
                (error) => {
                    console.log(error.text)
                    alert('Failed to send email, please try again.')
                }
            )
    }

    return (
        <>
            <div className='container contact-page'>
                <div className='text-zone'>
                    <h1>
                        <AnimatedLetters
                            letterClass={letterClass}
                            strArray={['C','o','n','t','a','c','t',' ','M','e']}
                            idx={15}
                        />
                    </h1>
                    <p>
                        Alongside my main work, I also do freelance work regarding things like designing and creating websites, 
                        implementing website modifications and additons, and small to large scale enterprise software systems. 
                        Quotes and estimates are based upon the extensiveness of said project. Please feel free to reach 
                        out to me with any questions or requests via the form below. Thanks.   
                    </p>
                    <div className='contact-form'>
                        <form ref={refForm} onSubmit={sendEmail}>
                            <ul>
                                <li className='half'>
                                    <input placeholder='Name' type='text' name='name' required/>
                                </li>
                                <li className='half'>
                                    <input placeholder='Email' type='email' name='email' required/>
                                </li>
                                <li>
                                    <input placeholder='Subject' type='text' name='subject' required/>
                                </li>
                                <li>
                                    <textarea placeholder='Message' name='message' required/>
                                </li>
                                <li>
                                    <input type='submit' className='flat-button' value='SEND'/>
                                </li>
                            </ul>   
                        </form>
                    </div>
                </div>
                <div className='info-map'>
                    Julio Lopez
                    <br/>
                    1600 Campus Ct.
                    <br/>
                    Abilene, TX 79601<br/>
                    United States<br/>
                    <span>juliol2540@gmail.com</span>
                </div>
                <div className='map-wrap'>
                    <MapContainer center={[32.4701, -99.7080]} zoom={13}>
                        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'/>
                        <Marker position={[32.4701, -99.7080]}>
                            <Popup>Julio is currently based here.</Popup>
                        </Marker>    
                    </MapContainer>
                </div>
            </div>
            <Loader type='pacman'/>
        </>
    )
} 

export default Contact